


































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import CalculoTetoStore from '@/components/RemuneracaoMedica/financeiro/Store/CalculoTetoStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney } from '@/utils/common'

@Component
export default class ViewFinanceiroTaxaAluguel extends Vue {
  menu: boolean = false

  $refs!: {
    formGarantia: any
  }

  form: any = {
    valid: true,
    anoMes: [(v: any) => !!v || 'Campo obrigatório'],
    regra: [(v: any) => !!v || 'Campo obrigatório'],
  }

  get getTetoStore() {
    return getModule(CalculoTetoStore, this.$store)
  }

  get regras() { return this.getTetoStore.listaTeto }
  get selectedRegra() { return this.getTetoStore.selectedRegra }
  set selectedRegra(value) { this.getTetoStore.setSelectedRegra(value) }

  get selectedMesReferencia() { return this.getTetoStore.selectedMesReferencia }
  set selectedMesReferencia(value) { this.getTetoStore.setSelectedMesReferencia(value) }

  get getMenu() { return this.menu }
  set getMenu(value: boolean) { this.menu = value }

  get showCard() {
    return this.getTetoStore.showErrorScreen || this.getTetoStore.showSuccessScreen
  }

  get successList() {
    return this.getTetoStore.successList
  }

  get errorMessage() {
    return this.getTetoStore.errorMessage
  }

  maskMoney(value: any) {
    return maskMoney(value)
  }

  async getPreviaTeto() {
    if (!this.$refs.formGarantia.validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha todos os campos!', icon: 'warning', color: '#C62828' })
      return
    }

    const response = await this.getTetoStore.getPreviaTeto()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro na requisição', icon: 'warning', color: '#C62828' })
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Prévia realizada com sucesso!', icon: 'done', color: '#2E7D32' })
  }

  async calcular() {
    const response = await this.getTetoStore.calcularTeto()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao calcular!', icon: 'warning', color: '#C62828' })
      return
    }

    this.getTetoStore.setShowSuccessScreen(false)
    this.selectedMesReferencia = ''
    this.selectedRegra = ''
    this.$refs.formGarantia.resetValidation()
    EventBus.$emit('setSnackbar', { show: true, text: 'Item calculado com sucesso!', icon: 'done', color: '#2E7D32' })
  }

  async mounted() {
    this.selectedMesReferencia = ''
    this.selectedRegra = ''
    await this.getTetoStore.getListaTeto()
  }
}
